/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { FAQ } from './FAQ'
import { FAQFromJSON, FAQFromJSONTyped, FAQToJSON } from './FAQ'

/**
 *
 * @export
 * @interface PaginatedFAQAdmin
 */
export interface PaginatedFAQAdmin {
  /**
   *
   * @type {Array<FAQ>}
   * @memberof PaginatedFAQAdmin
   */
  results: Array<FAQ>
  /**
   *
   * @type {number}
   * @memberof PaginatedFAQAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedFAQAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedFAQAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedFAQAdmin interface.
 */
export function instanceOfPaginatedFAQAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedFAQAdminFromJSON(json: any): PaginatedFAQAdmin {
  return PaginatedFAQAdminFromJSONTyped(json, false)
}

export function PaginatedFAQAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedFAQAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(FAQFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedFAQAdminToJSON(value?: PaginatedFAQAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(FAQToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
